module.exports = __webpack_public_path__ + "static/img/4.32deb31.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/zh/4.png
// module id = ixvI
// module chunks = 0